const breadCrumb = "Rendimento - Consulta do Rendimento";

const routes = [
  {
    path: "/gerar-relatorio-de-rendimento-escolar-geral",
    name: "gerar-relatorio-de-rendimento-escolar-geral",
    meta: {
      //allowedPermissions: ["rendimento_turma_list"],
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/GerarRelatorioDeRendimentoEscolarGeral/GerarRelatorioDeRendimentoEscolarGeral.vue"
      ),
  },
];

export default routes;
